import React, { useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button } from "@mui/material";
import { usePurchaseInvoiceContext } from "../../../context/PurchaseInvoiceContext";
import { formatDate } from "../../../utils/dateFormatter";
import "./purchaseInvoices.css";

const PurchaseInvoices = () => {
  const { invoices, loading, getPurchaseInvoices, cancelPurchaseInvoice } =
    usePurchaseInvoiceContext();

  useEffect(() => {
    getPurchaseInvoices();
  }, []);

  const handleCancelInvoice = async (id) => {
    if (
      !window.confirm(
        "هل أنت متأكد من إلغاء هذه الفاتورة؟\nسيتم خصم الكميات وتحديث الرصيد."
      )
    ) {
      return;
    }

    try {
      const response = await cancelPurchaseInvoice(id);
      if (response.status === "success") {
        alert("✅ " + response.message);
        getPurchaseInvoices(); // إعادة تحميل الفواتير
      }
    } catch (err) {
      alert("❌ " + (err.response?.data?.message || "حدث خطأ أثناء الإلغاء"));
    }
  };

  const columns = [
    {
      accessorKey: "id",
      header: "رقم الفاتورة",
      size: 100,
    },
    {
      accessorKey: "supplier_name",
      header: "اسم المورد",
      size: 200,
      Cell: ({ row }) => (
        <a
          href={`/supplier/${row.original.supplier_id}`}
          style={{
            color: "#1976d2",
            textDecoration: "none",
            fontWeight: 500,
          }}
          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        >
          {row.original.supplier_name}
        </a>
      ),
    },
    {
      accessorKey: "supplier_phone",
      header: "هاتف المورد",
      size: 150,
    },
    {
      accessorKey: "total_amount",
      header: "المبلغ الإجمالي",
      size: 150,
      Cell: ({ cell }) => `${parseFloat(cell.getValue()).toFixed(2)} ₪`,
    },
    {
      accessorKey: "created_at",
      header: "تاريخ الفاتورة",
      size: 150,
      Cell: ({ cell }) => formatDate(cell.getValue()),
    },
    {
      accessorKey: "notes",
      header: "ملاحظات",
      size: 250,
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      accessorKey: "is_canceled",
      header: "الحالة",
      size: 100,
      Cell: ({ row }) =>
        row.original.is_canceled == 1 ? (
          <span
            style={{
              padding: "4px 12px",
              backgroundColor: "#fee2e2",
              color: "#dc2626",
              borderRadius: "4px",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            ملغية
          </span>
        ) : (
          <span
            style={{
              padding: "4px 12px",
              backgroundColor: "#d1fae5",
              color: "#059669",
              borderRadius: "4px",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            نشطة
          </span>
        ),
    },
    {
      header: "الإجراءات",
      size: 200,
      Cell: ({ row }) => (
        <div style={{ display: "flex", gap: 8 }}>
          <a
            href={`/purchase-invoice/${row.original.id}`}
            style={{
              padding: "6px 16px",
              backgroundColor: "#0b3d91",
              color: "white",
              textDecoration: "none",
              borderRadius: "4px",
              fontSize: "0.875rem",
              fontWeight: 500,
              display: "inline-block",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#083070")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#0b3d91")}
          >
            عرض التفاصيل
          </a>
          {row.original.is_canceled != 1 && (
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#ef4444",
                "&:hover": { backgroundColor: "#dc2626" },
              }}
              onClick={() => handleCancelInvoice(row.original.id)}
            >
              إلغاء
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="purchase-invoices-page">
      <div className="page-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h2 className="page-title" style={{ margin: 0 }}>
            فواتير الشراء ({invoices.length})
          </h2>
          <a
            href="/new-purchase-invoice"
            style={{
              backgroundColor: "#0b3d91",
              color: "white",
              padding: "10px 20px",
              borderRadius: "4px",
              fontWeight: 600,
              textDecoration: "none",
              display: "inline-block",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#083070")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#0b3d91")}
          >
            + إضافة فاتورة شراء جديدة
          </a>
        </div>

        {loading ? (
          <p className="loading-text">جارٍ تحميل البيانات...</p>
        ) : (
          <div className="table-wrapper">
            <MaterialReactTable
              columns={columns}
              data={invoices}
              enableColumnOrdering
              localization={{
                toolbar: { searchPlaceholder: "بحث..." },
                noRecordsToDisplay: "لا توجد فواتير",
              }}
              muiTableBodyRowProps={{
                sx: {
                  "&:not(:last-child)": {
                    borderBottom: "8px solid transparent",
                  },
                  "& td": { borderBottom: "1px solid #ddd" },
                },
              }}
              muiTableBodyCellProps={{
                sx: { textAlign: "right", padding: "12px 16px" },
              }}
              muiTableHeadCellProps={{
                sx: {
                  textAlign: "right",
                  padding: "12px 16px",
                  backgroundColor: "#f5f5f5",
                  fontWeight: 600,
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchaseInvoices;
